<template>
  <img
    class="vuestic-logo"
    :class="{ 'vuestic-logo--icon': compact }"
    :height="renderHeight"
    :width="renderWidth"
    alt="Profit Tracking"
    :src="logoSource"
  />
</template>

<script lang="ts" setup>
import { computed, toRefs } from 'vue'
import { useColors } from '@/composables/ui'

/** Matches public/logo.svg viewBox (681.57 × 137). */
const WORDMARK_ASPECT = 681.57 / 137

const props = withDefaults(
  defineProps<{
    height?: number
    /** Use favicon mark instead of full wordmark (mobile navbar). */
    compact?: boolean
  }>(),
  {
    height: 28,
    compact: false,
  },
)

const { height, compact } = toRefs(props)
const { currentPresetName } = useColors()

const renderHeight = computed(() => height.value)
const renderWidth = computed(() => (compact.value ? height.value : Math.round(height.value * WORDMARK_ASPECT)))

const heightPx = computed(() => `${renderHeight.value}px`)
const widthPx = computed(() => `${renderWidth.value}px`)

const logoSource = computed(() => {
  if (compact.value) return '/favicon.svg'
  return currentPresetName.value === 'dark' ? '/logo_dark.svg' : '/logo.svg'
})
</script>

<style scoped>
.vuestic-logo {
  display: block;
  width: v-bind(widthPx);
  height: v-bind(heightPx);
  max-width: none;
  flex-shrink: 0;
  object-fit: contain;
  object-position: left center;
}
</style>
